import React, { useEffect, useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const BOOKING_URL = 'https://frame2.hotelpms.io/BookingFrameClient/hotel/F55A3319C2BD19986C5DAA828B4FFE6C/e2d8af9e-82cf-4b24-ba19-fc7b08142f0e/book/rooms';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/6DUh1kuDkNqXyfw6AnnkMF/PicsArt_02-06-12.01.24.png';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t('Cabañas', 'Cabins'),
    href: '#cabanas'
  }, {
    name: t('Servicios', 'Services'),
    href: '#servicios'
  }, {
    name: t('Actividades', 'Activities'),
    href: '#actividades'
  }, {
    name: t('Entorno', 'Surroundings'),
    href: '#entorno'
  }, {
    name: t('Reseñas', 'Reviews'),
    href: '#resenas'
  }, {
    name: t('Ubicación', 'Location'),
    href: '#ubicacion'
  }, {
    name: t('Contacto', 'Contact'),
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-background/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-4'}`} data-id="element-253" data-mp="olgnkxk3kqg6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254" data-mp="3s27b4qbq3m5m">
        <div className="flex justify-between items-center gap-4" data-id="element-255" data-mp="3s2qgl7k6si2r">
          <a href="#" className="flex flex-col min-w-0" data-id="element-256" data-mp="v4jjxrz3duv">
            <span className={`font-serif text-lg sm:text-xl font-bold whitespace-nowrap ${isScrolled ? 'text-primary' : 'text-white drop-shadow-md'}`} data-id="element-257" data-mp="5mvzledi616r">
              Cabañas Clarita
            </span>
            <span className={`hidden sm:block text-xs font-medium tracking-wider uppercase whitespace-nowrap ${isScrolled ? 'text-accent' : 'text-white/90 drop-shadow-md'}`} data-id="element-258" data-mp="39b62fakswc8v">
              Dina Huapi · Bariloche
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-7" data-id="element-259" data-mp="3b1clwd9oo7yq">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-accent ${isScrolled ? 'text-gray-600' : 'text-white/90 drop-shadow-md hover:text-white'}`} data-id="element-260" data-mp="361qa889i6zs1">
                {link.name}
              </a>)}

            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className={`flex items-center gap-1 text-sm font-medium transition-colors hover:text-accent ${isScrolled ? 'text-gray-600' : 'text-white/90 drop-shadow-md hover:text-white'}`} aria-label={t('Cambiar idioma', 'Change language')} data-id="element-261" data-mp="2s8igob1v3u7p">
              <Globe className="w-4 h-4" data-id="element-262" data-mp="a3r0zffgjulb" />
              {lang === 'es' ? 'EN' : 'ES'}
            </button>

            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${isScrolled ? 'bg-primary text-white hover:bg-primary-light' : 'bg-white text-primary hover:bg-background'}`} data-id="element-263" data-mp="f4oirqwk2mma">
              {t('Reservar', 'Book Now')}
            </a>

            <a href="#" aria-label={t('Inicio', 'Home')} className="shrink-0" data-id="element-264" data-mp="xtv5dp0gzydd">
              <img src={LOGO_URL} alt={t('Logo de Cabañas Clarita, alojamiento turístico', 'Cabañas Clarita logo, tourist accommodation')} className={`rounded-full bg-white object-cover transition-all duration-300 ${isScrolled ? 'w-11 h-11 ring-1 ring-surface' : 'w-14 h-14 ring-2 ring-white/70'}`} data-id="element-265" data-mp="k1x39y56f2qp" />
            </a>
          </nav>

          {/* Mobile actions */}
          <div className="md:hidden flex items-center gap-3" data-id="element-266" data-mp="3k2azkv6n1a0u">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className={`flex items-center gap-1 text-sm font-medium transition-colors ${isScrolled ? 'text-gray-600' : 'text-white drop-shadow-md'}`} aria-label={t('Cambiar idioma', 'Change language')} data-id="element-267" data-mp="3k56yomu824qv">
              <Globe className="w-4 h-4" data-id="element-268" data-mp="6o7n43irctx4" />
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
            <button className="p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={t('Abrir menú', 'Open menu')} aria-expanded={mobileMenuOpen} data-id="element-269" data-mp="1wzayzq1mug9">
              {mobileMenuOpen ? <X className={isScrolled ? 'text-primary' : 'text-white'} data-id="element-270" data-mp="ufmuiape61f8" /> : <Menu className={isScrolled ? 'text-primary' : 'text-white'} data-id="element-271" data-mp="pkpcwfe1qjqq" />}
            </button>
            <a href="#" aria-label={t('Inicio', 'Home')} className="shrink-0" data-id="element-272" data-mp="28bwg60x6ce52">
              <img src={LOGO_URL} alt={t('Logo de Cabañas Clarita', 'Cabañas Clarita logo')} className="w-10 h-10 rounded-full bg-white object-cover ring-1 ring-white/70" data-id="element-273" data-mp="2dar0566vo8qr" />
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-background shadow-lg border-t border-surface" data-id="element-274" data-mp="2w6z6yefjgro6">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-275" data-mp="30za9zq5kstky">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-800 hover:bg-surface/50 rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-276" data-mp="3502lyr5u1ckx">
                {link.name}
              </a>)}
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="block w-full text-center mt-4 px-5 py-3 rounded-md text-base font-medium bg-primary text-white hover:bg-primary-light" onClick={() => setMobileMenuOpen(false)} data-id="element-277" data-mp="1ewabiovwiwzn">
              {t('Reservar', 'Book Now')}
            </a>
          </div>
        </div>}
    </header>;
}